import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SmpLoadingContextType {
  isLoading: boolean;
  setLoading: (val: boolean) => void;
}

const SmpLoadingContext = createContext<SmpLoadingContextType | undefined>(undefined);

export const SmpLoadingProvider = ({ children }: { children: ReactNode }) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <SmpLoadingContext.Provider value={{ isLoading, setLoading: setIsLoading }}>
      {children}
    </SmpLoadingContext.Provider>
  );
};

export const useSmpLoading = () => {
  const ctx = useContext(SmpLoadingContext);
  if (!ctx) throw new Error("useSmpLoading must be used within SmpLoadingProvider");
  return ctx;
};
